export class BlogEntry {
    id: number;
    createdAt: Date = new Date();
    text: string;
    mainCategory: string;
    blogEntryComments: BlogEntryComment[];
    categories: Array<BlogEntryComment> = new Array<BlogEntryComment>();
}

export class BlogEntryComment {
    entityId: number;
    id: number;
    subject: string;
    text: string;
    timeStamp: Date = new Date();
    authorFirstName: null;
    authorLastName: null;
    authorName: string;
    authorImageName: string;
    authorCredits: string;
    authorWebAddress: string;
    isReview: boolean = false;
    parentId: null;
    parent?: null;
    replies: Array<BlogEntryComment> = new Array<BlogEntryComment>();
}
